<span style='white-space: pre;' [innerHTML]="message"></span>